import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { delay, map, Observable } from 'rxjs';

import { BaseHttpService } from '@shared/services-http/base-http.service';
import { IAddTachograpCompanyCardResponse, IAddTachographCompanyCardBody, IAssignCompanyCardToVehicleSchedule, IDownloadDriverTachoFilesBody, IGetDriverTachoFile, IGetDriverTachographFileSchedule, IGetFilesTachoBody, IGetListCompanyCard, IGetTachographDriverFileStatus, IGetTachographVehicleFileStatus, IGetVehicleTachoFile, IGetVehicleTachographFileSchedule, IUpdateTachographCompanyCardBody } from '@src/app/interfaces/api/files-ddd.interface';
import { WebResponse } from '@commons/models/remote.response/WebResponse';
import { NewDataStoreService } from '@shared/services/new-data-store.service';
import { IPagination } from '@src/app/interfaces/api/pagination.interface';
import { IGetTachographConfigResponse, IGetTachographDataRequest, ISetTachographConfig, ITachographDayData } from '@src/app/interfaces/tachograph.interface';
import { Vehicle } from '@commons/models/domain/Vehicle';
import { Driver } from '@commons/models/domain/Driver';

@Injectable({
  providedIn: 'root'
})
export class FilesDddService extends BaseHttpService {

  constructor(
    private httpClient: HttpClient,
    private newDataStoreService: NewDataStoreService,
  ) {
    super();
  }

  public GetDriverTachoFileList(data: IGetFilesTachoBody): Observable<IPagination<IGetDriverTachoFile>> {
    return this.httpClient.post<WebResponse>(this.getUrl('/GetDriverTachoFileList'), data)
      .pipe(
        delay(500),
        map(res => ({ ...res.Result, Result: res.Result.Result.map((el: IGetDriverTachoFile) => ({ ...el, Driver: this.newDataStoreService.getDriverById(el.DriverId) })) })),
      );
  }

  public GetVehicleTachoFileList(data: IGetFilesTachoBody): Observable<IPagination<IGetVehicleTachoFile>> {
    return this.httpClient.post<WebResponse>(this.getUrl('/GetVehicleTachoFileList'), data)
      .pipe(
        delay(500),
        map(res => ({ ...res.Result, Result: res.Result.Result.map((el: IGetVehicleTachoFile) => ({ ...el, Vehicle: this.newDataStoreService.getVehicleById(el.VehicleId) })) })),
      );
  }

  public DownloadDriverTachoFiles(data: IDownloadDriverTachoFilesBody): Observable<any> {
    return this.httpClient.post(this.getUrl('/DownloadDriverTachoFiles'), data, {
      observe: 'response',
      responseType: 'blob'
    });
  }

  public DownloadVehicleTachoFiles(data: IDownloadDriverTachoFilesBody): Observable<any> {
    return this.httpClient.post(this.getUrl('/DownloadVehicleTachoFiles'), data, {
      observe: 'response',
      responseType: 'blob'
    });
  }

  public GetTachographData(data: IGetTachographDataRequest): Observable<WebResponse<ITachographDayData[]>> {
    return this.httpClient.post<WebResponse>(this.getUrl('/GetTachographData'), data)
      .pipe(
        map(res => ({ ...res, Result: res.Result.Data })),
      );
  }

  public GetVehicleTachographFileSchedule(): Observable<WebResponse<{ Schedules: IGetVehicleTachographFileSchedule[] }>> {
    return this.httpClient.post<WebResponse>(this.getUrl('/GetVehicleTachographFileSchedule'), {});
  }

  public GetTachographVehicleFileStatus(): Observable<IGetTachographVehicleFileStatus[]> {
    return this.httpClient.get<WebResponse<{ StatusList: IGetTachographVehicleFileStatus[] }>>(this.getUrl('/GetTachographVehicleFileStatus'))
      .pipe(
        map(res => res.Result.StatusList),
      );
  }

  public ForceFileDownloadForVehicle(vehicleId: number): Observable<void> {
    return this.httpClient.post<void>(this.getUrl(`/ForceFileDownloadForVehicle/${vehicleId}`), {});
  }

  public SetTachographScheduleForVehicles(vehiclesIds: number[], isAdd: boolean = true): Observable<void> {
    return this.httpClient.post<void>(this.getUrl(`/SetTachographScheduleForVehicles`), { Ids: vehiclesIds, Value: isAdd });
  }

  public SetTachographConfig(data: ISetTachographConfig): Observable<void> {
    return this.httpClient.post<void>(this.getUrl(`/SetTachographConfig`), data);
  }

  public GetTachographConfig(): Observable<IGetTachographConfigResponse> {
    return this.httpClient.get<WebResponse<IGetTachographConfigResponse>>(this.getUrl(`/GetTachographConfig`)).pipe(map((res) => res.Result));
  }

  public GetTachographDriverFileStatus(): Observable<IGetTachographDriverFileStatus[]> {
    return this.httpClient.get<WebResponse<{ StatusList: IGetTachographDriverFileStatus[] }>>(this.getUrl('/GetTachographDriverFileStatus'))
      .pipe(
        map(res => res.Result.StatusList),
      );
  }

  public GetDriverTachographFileSchedule(): Observable<WebResponse<{ Schedules: IGetDriverTachographFileSchedule[] }>> {
    return this.httpClient.post<WebResponse>(this.getUrl('/GetDriverTachographFileSchedule'), {});
  }

  public ForceFileDownloadForDriver(driverId: number): Observable<void> {
    return this.httpClient.post<void>(this.getUrl(`/ForceFileDownloadForDriver/${driverId}`), {});
  }

  public SetTachographScheduleForDrivers(driverIds: number[], isAdd: boolean = true): Observable<void> {
    return this.httpClient.post<void>(this.getUrl(`/SetTachographScheduleForDrivers`), { Ids: driverIds, Value: isAdd });
  }

  public GetVehiclesWithTachographDisabled(): Observable<Vehicle[]> {
    return this.httpClient.get<WebResponse>(this.getUrl(`/GetVehiclesWithTachographDisabled`))
      .pipe(
        map(res => res.Result.Result),
      );
  }

  public GetDriversWithTachographDisabled(): Observable<Driver[]> {
    return this.httpClient.get<WebResponse>(this.getUrl(`/GetDriversWithTachographDisabled`))
      .pipe(
        map(res => res.Result.Result),
      );
  }

  public AddTachographCompanyCard(data: IAddTachographCompanyCardBody): Observable<IAddTachograpCompanyCardResponse> {
    return this.httpClient.post<WebResponse<IAddTachograpCompanyCardResponse>>(this.getUrl(`/AddTachographCompanyCard`), data).pipe(
      map(res => res.Result),
    );
  }

  public UpdateTachographCompanyCard(data: IUpdateTachographCompanyCardBody): Observable<void> {
    return this.httpClient.post<void>(this.getUrl(`/UpdateTachographCompanyCard`), data);
  }

  public DeleteTachographCompanyCard(id: number): Observable<void> {
    return this.httpClient.delete<void>(this.getUrl(`/DeleteTachographCompanyCard/${id}`))
  }

  public GetTachographCompanyCards(): Observable<IGetListCompanyCard> {
    return this.httpClient.get<WebResponse>(this.getUrl(`/GetTachographCompanyCards`))
      .pipe(
        map(res => res.Result),
      );
  }

  public AssignCompanyCardToVehicleSchedule(data: IAssignCompanyCardToVehicleSchedule): Observable<void> {
    return this.httpClient.post<void>(this.getUrl(`/AssignCompanyCardToVehicleSchedule`), data);
  }

  public UnassignCompanyCardFromSchedule(idVehicle: number): Observable<void> {
    return this.httpClient.delete<void>(this.getUrl(`/UnassignCompanyCardFromSchedule/${idVehicle}`));
  }

}
